function Ajax() {}
Ajax.showLoading = function() {
  $('.loader').show();
}
Ajax.hideLoading = function() {
  $('.loader').hide();
}
Ajax.prototype.filterAjaxClick = function(baseLink, render, callback) {
  if (Shopify.queryParams) {
    delete Shopify.queryParams.page;
  }
  var newUrl = this.filterCreateUrl(baseLink);
  history.pushState({
    param: Shopify.queryParams ? Shopify.queryParams : ''
  }, newUrl, newUrl);
  this.loadData(newUrl, render, callback);
}
Ajax.prototype.filterCreateUrl = function(baseLink) {
  var newQuery = '';
  if (Shopify.queryParams) {
    newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
  }
  if (baseLink) {
    if (newQuery != "")
      return baseLink + "?" + newQuery;
    else
      return baseLink;
  }
  return newQuery.length > 0 ? location.pathname + "?" + newQuery : location.pathname;
};
Ajax.prototype.loadData = function(url, render, callback) {
  $.ajax({
    type: 'get',
    url: url,
    beforeSend: function() {
      Ajax.showLoading();
    },
    success: function(data) {
      render(data, callback);
      Ajax.hideLoading();
    },
    error: function(xhr, text) {
      Ajax.hideLoading();
    }
  });
}